import { BugReport, FeatureRequest, GeneralFeedback } from '../types/feedback';

const mockUser = {
  id: '1',
  name: 'Sarah Johnson',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
  role: 'user'
};

export const mockProducts = [
  'GistUZone',
  'GoCity Workspace',
  'GoCity Job',
  'GoCity Business'
];

export const mockCategories = [
  'User Interface',
  'Performance',
  'Security',
  'Documentation',
  'API',
  'Mobile App',
  'Desktop App',
  'Workspace Management',
  'Resource Booking',
  'Job Matching',
  'Skill Assessment',
  'Team Building',
  'Training Platform'
];

export const mockBugReports: BugReport[] = Array(10).fill(null).map((_, index) => ({
  id: `bug-${index + 1}`,
  type: 'bug',
  title: `Bug Report ${index + 1}`,
  description: 'Detailed description of the bug...',
  author: mockUser,
  createdAt: new Date(Date.now() - Math.random() * 10000000000),
  updatedAt: new Date(Date.now() - Math.random() * 10000000000),
  status: ['pending', 'approved', 'rejected', 'in-progress', 'completed'][Math.floor(Math.random() * 5)] as any,
  likes: Math.floor(Math.random() * 100),
  views: Math.floor(Math.random() * 1000),
  comments: Array(Math.floor(Math.random() * 5)).fill(null).map((_, i) => ({
    id: `comment-${i}`,
    content: 'Comment content...',
    author: mockUser,
    createdAt: new Date(),
    likes: Math.floor(Math.random() * 10),
    isOfficial: Math.random() > 0.8
  })),
  product: mockProducts[Math.floor(Math.random() * mockProducts.length)],
  category: mockCategories[Math.floor(Math.random() * mockCategories.length)],
  tags: ['bug', 'ui', 'critical'].slice(0, Math.floor(Math.random() * 3) + 1),
  steps: 'Steps to reproduce...',
  expectedBehavior: 'Expected behavior...',
  actualBehavior: 'Actual behavior...',
  browserInfo: 'Chrome 98.0.4758.102',
  priority: ['low', 'medium', 'high', 'critical'][Math.floor(Math.random() * 4)] as any
}));

export const mockFeatureRequests: FeatureRequest[] = Array(10).fill(null).map((_, index) => ({
  id: `feature-${index + 1}`,
  type: 'feature',
  title: `Feature Request ${index + 1}`,
  description: 'Detailed description of the feature...',
  author: mockUser,
  createdAt: new Date(Date.now() - Math.random() * 10000000000),
  updatedAt: new Date(Date.now() - Math.random() * 10000000000),
  status: ['pending', 'approved', 'rejected', 'in-progress', 'completed'][Math.floor(Math.random() * 5)] as any,
  likes: Math.floor(Math.random() * 100),
  views: Math.floor(Math.random() * 1000),
  comments: Array(Math.floor(Math.random() * 5)).fill(null).map((_, i) => ({
    id: `comment-${i}`,
    content: 'Comment content...',
    author: mockUser,
    createdAt: new Date(),
    likes: Math.floor(Math.random() * 10),
    isOfficial: Math.random() > 0.8
  })),
  product: mockProducts[Math.floor(Math.random() * mockProducts.length)],
  category: mockCategories[Math.floor(Math.random() * mockCategories.length)],
  tags: ['feature', 'enhancement', 'ux'].slice(0, Math.floor(Math.random() * 3) + 1),
  useCase: 'Use case description...',
  benefits: 'Benefits description...',
  alternatives: 'Current alternatives...',
  upvotes: Math.floor(Math.random() * 500),
  plannedVersion: Math.random() > 0.5 ? '2.0.0' : undefined
}));

export const mockFeedback: GeneralFeedback[] = Array(10).fill(null).map((_, index) => ({
  id: `feedback-${index + 1}`,
  type: 'feedback',
  title: `Feedback ${index + 1}`,
  description: 'Detailed feedback...',
  author: mockUser,
  createdAt: new Date(Date.now() - Math.random() * 10000000000),
  updatedAt: new Date(Date.now() - Math.random() * 10000000000),
  status: ['pending', 'approved', 'rejected', 'completed'][Math.floor(Math.random() * 4)] as any,
  likes: Math.floor(Math.random() * 100),
  views: Math.floor(Math.random() * 1000),
  comments: Array(Math.floor(Math.random() * 5)).fill(null).map((_, i) => ({
    id: `comment-${i}`,
    content: 'Comment content...',
    author: mockUser,
    createdAt: new Date(),
    likes: Math.floor(Math.random() * 10),
    isOfficial: Math.random() > 0.8
  })),
  product: mockProducts[Math.floor(Math.random() * mockProducts.length)],
  category: mockCategories[Math.floor(Math.random() * mockCategories.length)],
  tags: ['feedback', 'suggestion', 'improvement'].slice(0, Math.floor(Math.random() * 3) + 1),
  feedbackType: ['general', 'ui', 'performance', 'content', 'other'][Math.floor(Math.random() * 5)] as any,
  rating: Math.floor(Math.random() * 5) + 1,
  improvements: 'Suggested improvements...'
}));